import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useQueryClient } from 'react-query';

import { COOKIES } from '../../_shared/constants/cookies';
import ROUTES from '../../components/Routes/constants';
import RouteExternal from '../../components/Routes/RouteExternal';

import ApiService from '../../_shared/api/apiService';
import useFeatureFlags from '../../_shared/hooks/useFeatureFlags';
import { FEATURE_FLAG } from '../../_shared/constants/queryDefinition';
import { getCookie } from '../../_shared/utils/cookies';
import ChatFiveNine from '../../components/ChatFiveNine';
import LOCALSTORAGE from '../../_shared/constants/localStorage';
import FEATURE_FLAGS from '../../_shared/constants/featureFlags';
import { isMobileDevice } from '../../_shared/utils/userAgent';

const propTypes = {
  component: PropTypes.func.isRequired
};

const AuthenticatedRoute = ({ component: Component }) => {
  const queryClient = useQueryClient();
  const [isApiLoaded, setApiLoaded] = useState(false);
  const user = JSON.parse(window.localStorage.getItem('auth'))?.user;
  const uuId = user?.universalUserDealerId;

  const featureFlagList = useFeatureFlags();
  const isCsu = user?.superUserId && user?.superUserId !== user?.id;
  const isUserHardMigratedToOMP = user?.isHardMigratedToOmpCa;

  useEffect(() => {
    async function fetchApi() {
      const client = await ApiService();
      if (client) {
        setApiLoaded(true);
      }
    }

    fetchApi();
  }, []);

  useEffect(() => {
    if (
      !featureFlagList?.data?.featureFlags &&
      featureFlagList?.status === 'success' &&
      isApiLoaded &&
      Number.parseInt(uuId, 10) ===
        Number.parseInt(getCookie(COOKIES.USER_ID), 10)
    ) {
      queryClient.invalidateQueries(FEATURE_FLAG.KEY);
    }
  }, [
    featureFlagList?.data?.featureFlags,
    featureFlagList?.status,
    isApiLoaded,
    queryClient,
    uuId
  ]);

  useEffect(() => {
    if (
      isApiLoaded &&
      (isUserHardMigratedToOMP ||
        (featureFlagList?.data?.featureFlags &&
          (featureFlagList?.data?.featureFlags[
            FEATURE_FLAGS.IS_USER_HARD_MIGRATED_OMP
          ] ||
            (featureFlagList?.data?.featureFlags[
              FEATURE_FLAGS.SHOULD_REDIRECT_USER_TO_OMP
            ] &&
              sessionStorage.getItem(LOCALSTORAGE.SHOULD_REDIRECT_OMP) !==
                'false')))) &&
      isCsu === false &&
      !isMobileDevice()
    ) {
      window.open(process.env.REACT_APP_OMP_ENDPOINT, '_self');
    }
  }, [
    featureFlagList?.data?.featureFlags,
    isApiLoaded,
    isCsu,
    isUserHardMigratedToOMP
  ]);

  if (
    !getCookie(COOKIES.AUTH_TOKEN) &&
    process.env.NODE_ENV !== 'development'
  ) {
    return <RouteExternal link={ROUTES.TR4_ENDPOINT} />;
  }

  return isApiLoaded ? (
    <>
      <Component />
      <ChatFiveNine />
    </>
  ) : null;
};

AuthenticatedRoute.propTypes = propTypes;

export default AuthenticatedRoute;
